module.exports = __webpack_public_path__ + "media/src/img/payment/som-885fa4412f4c66c54b85e90b9bbc8867.svg";